import Ic1 from "../../Attachments/Icons/Ic1.png";
import Ic2 from "../../Attachments/Icons/Ic2.png";
import Ic3 from "../../Attachments/Icons/Ic3.png";
import Ic4 from "../../Attachments/Icons/Ic4.png";


const CounterData = [
    {
        icon: {
            src: Ic1,
            alt: "Ic1"
        },
        counts: "300k",
        title: "Users Active",
    },
    {
        icon: {
            src: Ic2,
            alt: "Ic2"
        },
        counts: "52,5k",
        title: "Artworks",
    },
    {
        icon: {
            src: Ic3,
            alt: "Ic3"
        },
        counts: "17,5k",
        title: "Artists",
    },
    {
        icon: {
            src: Ic4,
            alt: "Ic4"
        },
        counts: "35.58",
        title: "ETH Spent",
    },
]

export default CounterData